import { createContext, useContext } from 'react';
import { IAbstractWorkItemContext, IWorkItemDraft, IWorkItemOptions, IWorkItemTemplate } from "models/work-items";
import { AbstractWorkItemProvider } from './abstracts';
import IStepItem from 'models/work-items/IStepItem';

export interface IWorkItemDraftContext extends IAbstractWorkItemContext {    
    workItem: IWorkItemDraft | null;
    template: IWorkItemTemplate | null;
    options: IWorkItemOptions | null;
    activeStep: IStepItem | null;
    updateWorkItemDraft: (darft: IWorkItemDraft) => void;
    revalidate: () => void;
};

const WorkItemDraftContext = createContext<IWorkItemDraftContext>({
    workItem: null,
    template: null,
    options: null,
    activeStep: null,
    getOptionsForStatus: () => [],
    updateWorkItemDraft: (_draft: IWorkItemDraft) => {},
    revalidate: () => {}
});

const WorkItemDraftConsumer = WorkItemDraftContext.Consumer;

const useWorkItemDraftContext = () => useContext(WorkItemDraftContext);

type WorkItemDraftProviderProps = {
    value: IWorkItemDraftContext;
    children: React.ReactNode;
};

const WorkItemDraftProvider = (props: WorkItemDraftProviderProps) => {
    const { value, children } = props;
    return (
        <AbstractWorkItemProvider value={value}>
            <WorkItemDraftContext.Provider value={value}>
                {children}
            </WorkItemDraftContext.Provider>
        </AbstractWorkItemProvider>
    );
};

export default useWorkItemDraftContext;
export { WorkItemDraftProvider, WorkItemDraftConsumer };